module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/sa-icon-online_916cb1e.png";